module.exports = __webpack_public_path__ + "img/prio-header.096cf028.png";